export const isBlackPepper = true;